'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import React, { Suspense, useEffect } from 'react';
import { usePageLoaderStore } from '@/stores/pageLoaderStore';
import { cn } from '@/utils/cn';
// import { Icon } from '@iconify/react';
import { Spinner } from '@nextui-org/react';
import { color } from 'framer-motion';

function HandleOnCompleteChild() {
  const setter = usePageLoaderStore.use.setter();

  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => setter({ show: false }), [pathname, searchParams]);
  return null;
}

export function PageLoader() {
  const show = usePageLoaderStore.use.show();

  return (
    <React.Fragment>
      <Suspense>
        <HandleOnCompleteChild />
        <div
          className={cn(
            'fixed z-[1000] inset-0 grid place-items-center bg-content1/70 transition',
            show ? 'opacity-100 visible' : 'opacity-0 invisible',
          )}
        >
          {/* <Icon
            className="animate-spin"
            icon="mingcute:loading-3-fill"
            width={60}
          /> */}
          <Spinner size="lg" label="Loading..." labelColor="foreground" />
        </div>
      </Suspense>
    </React.Fragment>
  );
}
